import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CustomPagination from "../../Utility/CustomPagination";

const EarningsTable = () => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
    const navigate = useNavigate();
  const limit = 10;

  const fetchEarnings = async () => {
    setLoading(true);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE}/host/get-transactions?page=${currentPage}&per_page=${limit}`,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
        }
      );
      setTransactions(Array.isArray(res?.data?.data) ? res.data.data : []);
      if (res.data.pagination) {
        setCurrentPage(res.data.pagination.current_page);
        setTotalPages(res.data.pagination.last_page);
      } else if (res.data.meta) {
        setCurrentPage(res.data.meta.current_page);
        setTotalPages(res.data.meta.last_page);
      }
    } catch (err) {
      console.error("Error fetching earnings:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEarnings(currentPage);
  }, [currentPage]);

 const formatCurrency = (amount, currency = "USD") => {
  if (amount == null) return "—";

  // 🛡️ Handle null / undefined / non-string currency values safely
  const cur = typeof currency === "string" ? currency.trim() : "";

  const symbolMap = {
    USD: "$",
    AUD: "$",
    EUR: "€",
    INR: "₹",
    GBP: "£",
  };

  const isSymbol = ["$", "₹", "€", "£"].includes(cur);
  const symbol = isSymbol ? cur : symbolMap[cur] || "";
  const code = isSymbol ? "USD" : cur || "USD";

  const formattedAmount = parseFloat(amount).toFixed(2);
  const cleanAmount = formattedAmount.endsWith(".00")
    ? formattedAmount.slice(0, -3)
    : formattedAmount;

  return `${symbol} ${cleanAmount} ${code}`;
};



  // ✅ Show both date & time
  const formatDateTime = (dateStr) => {
    if (!dateStr) return "—";
    const date = new Date(dateStr);
    return date.toLocaleString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };



const goToBookingDetail = (bookingId) => {
  if (!bookingId) return;
  navigate(`/host-experience-detail/${bookingId}`);
};


  if (loading) return <p className="text-center py-4">Loading earnings…</p>;
  if (!transactions.length) return <p className="text-center py-4">No earnings found.</p>;

  return (
    <>
    <div className="table-responsive">
      <table className="table table-condensed table-striped tbl_algn_ar all-support-date">
        <thead>
          <tr>
            <th>Booking ID</th>
            <th>Date</th>
            <th>Guest Name</th>
            <th>Amount Received</th>
            <th>Payment Method</th>
            <th>Status</th>
            <th>Transaction ID</th>
          </tr>
        </thead>
        <tbody>
          {transactions.map((tx) => {
            let statusLabel = "";
            let statusColor = "";

            switch (tx.status) {
              case 1:
                statusLabel = "Completed";
                statusColor = "green";
                break;
              case 0:
                statusLabel = "Pending";
                statusColor = "orange";
                break;
              case 2:
                statusLabel = "Cancelled";
                statusColor = "red";
                break;
              default:
                statusLabel = "Unknown";
                statusColor = "gray";
            }

            return (
              <tr key={tx.id}>
                <td style={{ cursor: "pointer", fontWeight: "600" }}
  onClick={() => goToBookingDetail(tx.booking_id)}>{tx.booking_id || "—"}</td>
                <td>{formatDateTime(tx.updated_at)}</td>
                <td>
                  {tx.first_name
                    ? `${tx.first_name} ${tx.last_name || ""}`
                    : "—"}
                </td>
                <td>{formatCurrency(tx.total_price, tx.currency)}</td>

                <td>{tx.payment_method || "—"}</td>
                <td style={{ color: statusColor, fontWeight: 600 }}>
                  {statusLabel}
                </td>
                <td>{tx.payment_id || "—"}</td>
              </tr>
            );
          })}
        </tbody>
      </table>

      
    </div>

<div className="mt-3 d-flex justify-content-end">
        <CustomPagination
          currentPage={currentPage}
          lastPage={totalPages}
          onPageChange={handlePageChange}
        />
      </div>
    </>

  );
};

export default EarningsTable;
